import schedulesViewStateStore from "../../store/store";
import { INoteEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('UPDATE_NOTES_IN_VIEW', function updateNotesInView(
    notesInView: INoteEntity[],
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    const store = viewState ? viewState : schedulesViewStateStore();
    let notes: ObservableMap<string, INoteEntity> = store.notesInView;
    for (let i = 0; i < notesInView.length; i++) {
        notes.set(notesInView[i].id, notesInView[i]);
    }
});
